export const BASE_CLASS = 'mt-PanelRating'
export const MAX_SCORE = 10

export const LAYOUTS = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
}
